import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterWrapper = styled.footer`
  background: #15243A;
  color: white;
  padding: 3rem 0 1rem;
  margin-top: 5rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

const FooterSection = styled.div`
  h3 {
    margin-bottom: 1rem;
    color: #148D89;
    font-size: 1.2rem;
  }
  
  p, a {
    color: #E5E7EB;
    margin-bottom: 0.5rem;
    display: block;
    
    &:hover {
      color: white;
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding: 2rem 0 1rem;
  margin-top: 2rem;
  border-top: 1px solid #374151;
  color: #9CA3AF;
  
  p {
    margin-bottom: 0.5rem;
  }
`;


const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterContent>
        <FooterSection>
          <h3>Institut Genevois de Formation</h3>
          <p>Formation professionnelle médicale 100% en ligne</p>
          <p>Certifications reconnues</p>
          <p>Accompagnement personnalisé</p>
        </FooterSection>
        
        <FooterSection>
          <h3>Nos Formations</h3>
          <Link to="/secretaire-medical">Secrétaire Médical</Link>
          <Link to="/assistant-medical">Assistant Médical</Link>
        </FooterSection>
        
        
        <FooterSection>
          <h3>Contact</h3>
          <ContactInfo>
            <a href="tel:+33601485383">📞 +33 6 01 48 53 83</a>
            <a href="mailto:contact@institutgenevoisdeformation.fr">✉️ contact@institutgenevoisdeformation.fr</a>
            <p>📍 41 Grand Rue, 1er étage appt. 6</p>
            <p>74160 Saint-Julien-en-Genevois</p>
          </ContactInfo>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        <p>© 2024 Institut Genevois de Formation - Tous droits réservés</p>
      </Copyright>
    </FooterWrapper>
  );
};

export default Footer;